module.exports = __webpack_public_path__ + "img/Pre-rolled.328a4be7.svg";